import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

/** A surface: a bordered panel holding one subject. */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-lg border border-border bg-card p-6 shadow-sm", className)}
      {...props}
    />
  );
}

/**
 * A card's heading row: title and description on the left, actions on the
 * right. Use inside a `Card` whose padding the header shares.
 */
export function CardHeader({
  title,
  description,
  actions,
  className,
  headingLevel = 2,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  headingLevel?: 2 | 3;
}) {
  const Heading = headingLevel === 2 ? "h2" : "h3";
  return (
    <div className={cn("mb-4 flex flex-wrap items-start justify-between gap-3", className)}>
      <div className="flex min-w-0 flex-col gap-1">
        <Heading className="text-base font-semibold leading-tight">{title}</Heading>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
